/**
 * Application route paths
 */
export const ROUTES = {
  HOME: '/',

  AUTH: {
    LOGIN: '/login',
    SIGNUP: '/sign-up',
  },

  DASHBOARD: {
    DIGEST: '/digest',
  },

  ARCHIVE: '/archive',
  MANAGE: '/manage',
  ACCOUNT: '/account',

  NOTIFICATIONS: '/notifications',

  ADMIN: {
    HOME: '/admin',
    USERS: '/admin/users',
    ANALYTICS: '/admin/analytics',
  },

  USER: {
    CONTACT_US: '/contact-us',
  },

  UNAUTHENTICATED: {
    FAQ: '/faqs',
    PRIVACY_POLICY: '/privacy',
    TERMS_AND_CONDITIONS: '/terms-of-service',
    CONTACT_US: '/contact-us',
  },

  AUTHENTICATED: {
    MY_PROFILE: '/my-profile',
  },
} as const;

export type Route = typeof ROUTES;

/**
 * API endpoint paths
 */
export const API_ENDPOINTS = {
  // Auth
  AUTH_LOGIN: '/v1/auth/login',
  AUTH_REGISTER: '/v1/auth/register',
  AUTH_LOGOUT: '/v1/auth/logout',
  AUTH_REFRESH: '/v1/auth/refresh',
  AUTH_SIGNUP_AVAILABILITY: '/v1/auth/signup-availability',
  AUTH_LOGIN_AVAILABILITY: '/v1/auth/login-availability',
  AUTH_PHONE_SIGNUP: '/v1/auth/phone-signup',
  AUTH_PHONE_LOGIN: '/v1/auth/phone-login',
  AUTH_EMAIL_LOGIN: '/v1/auth/email-login',
  AUTH_GENERATE_OTP: '/v1/otp/generate',
  AUTH_VALIDATE_OTP: '/v1/otp/validate',

  // Users
  USERS: '/v1/users',
  USER_BY_ID: (id: string) => `/v1/users/${id}`,
  USER_PROFILE: '/v1/users/profile',
  USER_PHONE_CHECK: '/v1/users/me/phone/check',
  USER_PHONE: '/v1/users/me/phone',

  // Waitlist
  WAITLIST_JOIN: '/v1/waitlist',
  WAITLIST_COUNT: '/v1/waitlist/count',

  // General
  HEALTH: '/v1/health',

  // Subscriptions
  SUBSCRIPTIONS_ME: '/v1/subscriptions/me',
  SUBSCRIPTIONS_ME_SPORTS: '/v1/subscriptions/me/sports',
  SUBSCRIPTIONS_ME_PAYMENTS: '/v1/subscriptions/me/payments',
  SUBSCRIPTIONS_CHECKOUT: '/v1/subscriptions/checkout',
  SUBSCRIPTIONS_CANCEL: '/v1/subscriptions/cancel',
  SUBSCRIPTIONS_SWAP_SPORT: '/v1/subscriptions/swap-sport',
  SUBSCRIPTIONS_PRO_SPORTS: '/v1/subscriptions/pro-sports',
  SUBSCRIPTIONS_PLANS: '/v1/subscriptions/plans',

  // Onboarding
  ONBOARDING_VISITOR_SESSION: '/v1/onboarding/visitors/session',
} as const;
